import { Pipe, PipeTransform } from '@angular/core';
import { CatalogData } from '../providers/catalog';
import { ENV } from '@app/env';
import { EventData } from '../providers/event';
import { CommercialSamplesData } from '../providers/commercial_samples';

@Pipe({
  name: 'favoriteData'
})

export class favoriteDataPipe implements PipeTransform {

  public clientId = ENV.client;

  constructor(
    private catalogData: CatalogData,
    private eventData: EventData,
    private commercialSamplesData: CommercialSamplesData,
  ) { }

  transform(value: any, id: string, eventId: string): any {
    switch (value) {
      case "product":
        return this.catalogData.getCatalogById(this.clientId, id);

      case "staff":
        return this.eventData.getStaffData(this.clientId, id);

      case "stand":
        if (eventId) {
          return this.commercialSamplesData.getEventCommercialSampleById(eventId, id)
        } else {
          return this.commercialSamplesData.getCommercialSampleById(id);
        }

      case "event":
        return this.eventData.getEventInfo(this.clientId, id);

      case "agenda":
        return this.eventData.getAgendaById(this.clientId, eventId, id);
    }
  }
}


// WEBPACK FOOTER //
// ./src/pipes/favorite-data.pipe.ts